// Custom Shopify Script - Show/Hide Elements
(function() {
    'use strict';

    // Wait for DOM to be fully loaded
    function onDocumentReady(callback) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            callback();
        }
    }
function isColumnAvailable(column) {
    if (!column) return false;

    let computedStyle = window.getComputedStyle(column);
    return computedStyle.display !== 'none';
  }
    // Main initialization function
    function init() {

        //console.log('Custom script initialized');
        
        // const radios = document.querySelectorAll('input[data-instant-disabled="true"]');
        // if(radios){
        //     radios.forEach(radio => {
        //     // make cursor show not-allowed
        //     radio.style.cursor = "not-allowed";

        //     // block clicks
        //     radio.addEventListener("click", (e) => {
        //         e.preventDefault();
        //         e.stopPropagation();
        //     });
        //     });
        // }

        // 
        const save_percent_column = document.querySelector('.save_percent_column');
        const save_percent_field = document.querySelector('.save_percent_field');
if (save_percent_column && !isColumnAvailable(save_percent_field)) {
    save_percent_column.remove();
}
        const starting_from_column = document.querySelector('.starting_from_column');
        const comparison_price_field = document.querySelector('.comparison_price_field');
        if (starting_from_column && !isColumnAvailable(comparison_price_field)) {
    starting_from_column.remove();
}
    }

    // function isColumnAvailable(column)
    // {
    //     if (column) {
    //         let computedStyle = window.getComputedStyle(column);
    //         return computedStyle.display !== 'none';
    //     }
    // }

    // Initialize when document is ready
    onDocumentReady(init);

    // Handle Shopify section reloads (for theme editor)
    document.addEventListener('shopify:section:load', init);


})();









